import { render, staticRenderFns } from "./OlympicsRegulationConfirmModal.vue?vue&type=template&id=138bb8a2"
import script from "./OlympicsRegulationConfirmModal.vue?vue&type=script&lang=js"
export * from "./OlympicsRegulationConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./OlympicsRegulationConfirmModal.vue?vue&type=style&index=0&id=138bb8a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports